import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import ModalLoadingMessage from "../../../../components/modals/ModalLoadingMessage";
import { check } from "./check";
import Bracket from "./Bracket";

const EventBrackets = ({ activeTab, event, organize }) => {
  const theme = useTheme();

  const [hoverPlayer, setHoverPlayer] = useState(null);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [brackets, setBrackets] = useState(null);
  const [pairings, setPairings] = useState(null);
  const [hasRematch, setHasRematch] = useState(true);
  const [isTopCut, setIsTopCut] = useState(false);

  useEffect(() => {
    check(
      event,
      setPairings,
      setBrackets,
      setHasRematch,
      setLoadingMessage,
      setIsTopCut
    );
    // eslint-disable-next-line
  }, [activeTab, event]);

  const getBrackets = (index, bracketList) => {
    return bracketList && bracketList[index]?.rounds
      ? bracketList[index].rounds
      : {};
  };

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container sx={{ gap: 2 }}>
        {organize && (
          <Grid item xs={12}>
            <Typography variant="h3">Brackets</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Box
            sx={{
              width: "100%",
              maxHeight: "calc(100vh - 100px)",
              overflow: "auto",
            }}
          >
            <Bracket
              podNum={1}
              rounds={getBrackets(1, brackets)}
              event={event}
              hasRematch={hasRematch}
              hoverPlayer={hoverPlayer}
              pairings={pairings}
              setHoverPlayer={setHoverPlayer}
              theme={theme}
              isFirstRound
              headerText={isTopCut ? "Top cut" : "Championship Bracket"}
            />
            {event?.doubleElimination && (
              <Bracket
                podNum={2}
                rounds={getBrackets(2, brackets)}
                event={event}
                hasRematch={hasRematch}
                hoverPlayer={hoverPlayer}
                pairings={pairings}
                setHoverPlayer={setHoverPlayer}
                theme={theme}
                headerText="Elimination Bracket"
              />
            )}
          </Box>
        </Grid>
      </Grid>

      {loadingMessage}

      {Boolean(loadingMessage) && (
        <ModalLoadingMessage open message={loadingMessage} />
      )}
    </Container>
  );
};

export default EventBrackets;
